import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './main.scss';
import App from './App';
import {
  LoaderProvider,
} from "./context/LoaderContext";
import { AuthProvider } from './context/AdminAuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <LoaderProvider>
        <AuthProvider>
           <App />
        </AuthProvider>
    </LoaderProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
